import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type AudienceBandHeaderProps = {
  variant: 'personal' | 'corporate';
};

export default function AudienceBandHeader({ variant }: AudienceBandHeaderProps) {
  const { t } = useTranslation();
  const href = variant === 'personal' ? '/personal' : '/corporate';

  return (
    <section className="relative py-10 md:py-14 bg-primary-950 border-y border-accent-500/20">
      <div className="max-w-[1280px] mx-auto px-6 sm:px-8 md:px-12 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-5 md:gap-8">
          <div>
            <p className="section-title-en text-accent-500/70 text-[12px] tracking-[0.16em] mb-2">
              {t(`home.audienceBand.${variant}.tagEn`)}
            </p>
            <h2 className="font-heading text-[19px] md:text-[22px] text-background-50 tracking-[0.05em] mb-2">
              {t(`home.audienceBand.${variant}.title`)}
            </h2>
            <p className="text-[14px] md:text-[15px] text-background-200/80 tracking-[0.02em] leading-relaxed max-w-2xl">
              {t(`home.audienceBand.${variant}.lead`)}
            </p>
          </div>
          <Link
            to={href}
            className="shrink-0 inline-flex items-center gap-3 self-start md:self-auto px-7 py-3 border border-accent-500/50 hover:border-accent-500 hover:bg-accent-500/10 text-accent-400 hover:text-accent-300 text-[14px] tracking-[0.1em] transition-all duration-300 whitespace-nowrap"
          >
            {t(`home.audienceBand.${variant}.cta`)}
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
